const HOMEPAGE = "/walmartconnect"
export const isDevOrLocal = (location: string): boolean => {
	return isDev(location) || isLocal(location)
}

const isDev = (location: string): boolean => {
	const isDevRegex = /[-.]dev\.walmart.com/
	return isDevRegex.test(location)
}

export const isLocal = (location: string): boolean => {
	const isLocalRegex = /localhost/
	return isLocalRegex.test(location)
}

export const getBaseURL = (): string => {
	return window.location.origin + HOMEPAGE
}
